/* global $ */
/* eslint no-unused-vars: 0 */

const topNav = document.querySelector('.main-header');
const html = document.documentElement;
const alertBar = document.querySelector('.alert-bar');

setTimeout(() => {
	if (alertBar) {
		const closeAlertButton = document.querySelector('.alert-bar__close');
		// set the seen session storage value, optionally used to show alert only once
		sessionStorage.setItem('alert-seen', 'seen');

		closeAlertButton.addEventListener('click', (e) => {
			e.preventDefault();
			// update the height in case of window resizing
			const alertHeight = alertBar.offsetHeight;
			// set the current height plus 5 as max-height to transition from - helps with smoothness + predictability
			alertBar.style.setProperty(
				'--alert-max-height',
				`${ alertHeight + 5 }px`
			);
			// close the alert
			setTimeout(() => {
				// use transition prop from alert-bar.scss
				alertBar.style.transition = 'var(--alert-transition, 300ms)';
				// transition to 0 max-height
				alertBar.style.setProperty('--alert-max-height', 0);
				// set session storage value for option keep hidden after close
				sessionStorage.setItem('alert-closed', 'bye');
				// transition on the alert bar finishes
				alertBar.addEventListener('transitionend', () => {
					alertBar.style.display = 'none';
				});
			}, 5);
		});
	}
}, 1);
